import Resource from '../../../api/resource';
import request from "../../../utils/request";

class Roles extends Resource {
    constructor() {
        super('roles');
    }

    userRoleAndPermissions(user_id) {
        return request({
            url: `/roles/user/${user_id}`,
            method: 'get',
        })
    }

    updateUserRoleAndPermissions(resource, user_id) {
        return request({
            url: `/roles/user/${user_id}`,
            method: 'put',
            data: resource,
        })
    }


    editPermissions(data, id) {
        return request({
            url: `/roles/permissions/edit/${id}`,
            method: 'put',
            data: data,
        })
    }

    editRole(data, id) {
        return request({
            url: `/roles/role/edit/${id}`,
            method: 'put',
            data: data,
        })
    }

}

export {Roles as default};
